const adaFunctions = () => {

	if($('.wpcf7').length) {
		$('[name="arrival-date"]').removeAttr('aria-required');
	}

	if($('#sb_instagram').length) {
		$('.svg-inline--fa').removeAttr('role');
	}

	// ADA for AdRoll banner

	// Wait for AdRoll banner to be injected
	const observer = new MutationObserver((mutations) => {
		const adrollBanner = document.querySelector('#adroll_consent_banner');
		
		if (adrollBanner) {
			makeAdrollBannerAccessible(adrollBanner);
			watchForOverlay();
			observer.disconnect();
		}
	});

	observer.observe(document.body, {
		childList: true,
		subtree: true
	});

	function watchForOverlay() {
		const overlayObserver = new MutationObserver((mutations) => {
			const adrollOverlay = document.querySelector('#adroll_consent_overlay');
			if (adrollOverlay) {
				makeAdrollOverlayAccessible(adrollOverlay);
			}
		});

		overlayObserver.observe(document.body, {
			childList: true,
			subtree: true
		});
	}

	function makeAdrollBannerAccessible(banner) {
		banner.setAttribute('role', 'dialog');
		banner.setAttribute('aria-modal', 'true');
		banner.setAttribute('aria-label', 'Cookie Consent Banner');

		const mainContent = document.querySelector('#container');
		handleVisibilityChange(banner, mainContent);

		const styleObserver = new MutationObserver(() => handleVisibilityChange(banner, mainContent));
		styleObserver.observe(banner, {
			attributes: true,
			attributeFilter: ['style', 'class', 'hidden']
		});
	}

	function makeAdrollOverlayAccessible(overlay) {
		overlay.setAttribute('role', 'presentation');
		overlay.setAttribute('aria-hidden', 'true');

		const mainContent = document.querySelector('#container');
		handleVisibilityChange(overlay, mainContent);

		const styleObserver = new MutationObserver(() => handleVisibilityChange(overlay, mainContent));
		styleObserver.observe(overlay, {
			attributes: true,
			attributeFilter: ['style', 'class', 'hidden']
		});
	}

	function handleVisibilityChange(element, mainContent) {
		const isHidden = isElementHidden(element);

		const banner = document.querySelector('#adroll_consent_banner');
		const overlay = document.querySelector('#adroll_consent_overlay');
		
		const isBannerVisible = banner && !isElementHidden(banner);
		const isOverlayVisible = overlay && !isElementHidden(overlay);

		if (mainContent) {
			mainContent.setAttribute('aria-hidden', isBannerVisible || isOverlayVisible);
			
			const mainContentFocusable = mainContent.querySelectorAll(
				'a[href], button, input, select, textarea, [tabindex]'
			);
			
			mainContentFocusable.forEach(el => {
				if (el._tabIndexObserver) {
					el._tabIndexObserver.disconnect();
					delete el._tabIndexObserver;
				}

				if (isBannerVisible || isOverlayVisible) {
					if (!el.hasAttribute('data-original-tabindex') && 
						el.hasAttribute('tabindex') && 
						el.getAttribute('tabindex') !== '-1') {
						el.setAttribute('data-original-tabindex', el.getAttribute('tabindex'));
					}
					el.setAttribute('tabindex', '-1');
					
					const tabIndexObserver = new MutationObserver((mutations) => {
						if (el.getAttribute('tabindex') !== '-1') {
							el.setAttribute('tabindex', '-1');
						}
					});
					
					tabIndexObserver.observe(el, {
						attributes: true,
						attributeFilter: ['tabindex']
					});
					
					el._tabIndexObserver = tabIndexObserver;
				} else {
					if (el.hasAttribute('data-original-tabindex')) {
						el.setAttribute('tabindex', el.getAttribute('data-original-tabindex'));
						el.removeAttribute('data-original-tabindex');
					} else {
						el.removeAttribute('tabindex');
					}
					el.style.setProperty('outline', '', 'important');
					el.style.setProperty('outline-offset', '', 'important');
				}
			});
		}

		if (isHidden) {
			if (element.contains(document.activeElement)) {
				const focusTarget = 
					mainContent.querySelector('main') || 
					mainContent.querySelector('[role="main"]') || 
					document.body;

				document.activeElement.blur();
				element.setAttribute('aria-hidden', 'true');

				setTimeout(() => {
					focusTarget.focus();
				}, 0);
			} else {
				element.setAttribute('aria-hidden', 'true');
			}
		} else {
			if (element.id === 'adroll_consent_banner') {
				element.removeAttribute('aria-hidden');
			}
		}
	}

	// Helper function to check if an element is hidden
	function isElementHidden(element) {
		return (
			element.style.display === 'none' ||
			element.style.visibility === 'hidden' ||
			element.hidden ||
			window.getComputedStyle(element).display === 'none' ||
			window.getComputedStyle(element).visibility === 'hidden'
		);
	}
}
